import $ from 'jquery';
import "iframe-resizer";


$(document).ready(function() {
    if ( $('.embed-iframe').length) {

        iFrameResize({ log: true })

    }
});







